import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
			name: 'Home',
			component: resolve => require(['@/components/Home/Home'], resolve)
    },
    {
      path: '/stockList',
			name: 'stockList',
			component: resolve => require(['@/components/stockListPage/stockList'], resolve)
    },
    {
      path: '/stockDetails',
			name: 'stockDetails',
			component: resolve => require(['@/components/stockListPage/stockDetails'], resolve)
    },
    {
      path: '/BusinessMain',
			name: 'BusinessMain',
			component: resolve => require(['@/components/Business/BusinessMain'], resolve)
    },
    {
      path: '/businessDetails',
			name: 'businessDetails',
			component: resolve => require(['@/components/Business/businessDetails'], resolve)
    },
    {
      path: '/teamPage',
			name: 'teamPage',
			component: resolve => require(['@/components/Business/teamPage'], resolve)
    },
    {
      path: '/search',
			name: 'search',
			component: resolve => require(['@/components/Home/search'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js